define.alias("shared/components/shared/social/instagram-modal/available-page", "calendar/components/shared/social/instagram-modal/available-page");